// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pxkP-","wrapper":"Footer_wrapper__JYT9-","link":"Footer_link__QnF9p","onboarding":"Footer_onboarding__qJWrp"};